import { Entity, EntityMap, RejectedError } from './types';

import { objectWithKeys, objectWithoutKeys } from '.';

/**
 * Adds these entities to the map of rejected entities, and removes them from the map of pending entities.
 */
export const moveToRejected: <T extends Entity>(
  state: EntityMap<T>,
  ids: T['id'][],
  error: RejectedError
) => EntityMap<T> = (state, ids, error) => {
  const newPending = objectWithoutKeys<boolean>(state.pending.byId, ids);
  const newRejected = objectWithKeys<RejectedError>(state.rejected.byId, ids, error);

  return {
    ...state,
    pending: {
      ...state.pending,
      byId: newPending,
    },
    rejected: {
      ...state.rejected,
      byId: newRejected,
    },
  };
};
